// Docs:
// https://github.com/FortAwesome/vue-fontawesome
// https://fontawesome.com/icons
// https://fontawesome.com/how-to-use/on-the-web/styling/sizing-icons

// Examples:
// <font-awesome-icon :icon="['fas|far', 'compass']" />
// <font-awesome-icon :icon="['fas|far', 'compass']" size="xs|sm|lg|2x|3x|4x" />

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faCompass as fasCompass,
  faCircle as fasCircle,
  faUser as fasUser,
  faUserCircle as fasUserCircle,
  faBars as fasBars,
  faSignOutAlt as fasSignOutAlt,
  faTimes as fasTimes,
  faExclamationTriangle as fasExclamationTriangle,
  faCheckCircle as fasCheckCircle,
  faChevronUp as fasChevronUp,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faMapMarkerAlt as fasMapMarkerAlt,
  faPlusCircle as fasPlusCircle,
  faPlus as fasPlus,
  faSort as fasSort,
  faExchangeAlt as fasExchangeAlt,
  faFolderOpen as fasFolderOpen,
  faPen as fasPen,
  faSignInAlt as fasSignInAlt,
  faSpinner as fasSpinner,
  faThLarge as fasThLarge,
  faEnvelope as fasEnvelope,
  faCheck as fasCheck,
  faSearch as fasSeach,
  faRocket as fasRocket,
  faStar as fasStar,
  faMagic as fasMagic,
  faAsterisk as fasAsterisk,
  faArrowsAlt as fasArrowsAlt,
  faArrowAltCircleDown as fasArrowAltCircleDown,
  faLongArrowAltDown as fasLongArrowAltDown,
  faCalendarAlt as fasCalendarAlt,
  faLongArrowAltRight as fasLongArrowAltRight,
  faMapMarkedAlt as fasMapMarkedAlt,
  faShareAlt as fasShareAlt,
  faFileAlt as fasFileAlt,
  faFileContract as fasFileContract,
  faTags as fasTags,
  faGlobeAmericas as fasGlobeAmericas,
  faClipboardList as fasClipboardList,
  faFileInvoice as fasFileInvoice,
  faCompressArrowsAlt as fasCompressArrowsAlt,
  faExpandArrowsAlt as fasExpandArrowsAlt,
  faTrashAlt as fasTrashAlt,
  faListUl as fasListUl,
  faListAlt as fasListAlt,
  faUserEdit as fasUserEdit,
  faFillDrip as fasFillDrip,
  faDownload as fasDownload,
  faUpload as fasUpload,
  faGlobe as fasGlobe,
  faEye as fasEye,
  faEdit as fasEdit,
  faAngleLeft as fasAngleLeft,
  faAngleDoubleLeft as fasAngleDoubleLeft,
  faAngleRight as fasAngleRight,
  faAngleDoubleRight as fasAngleDoubleRight,
  faPrint as fasPrint,
  faCog as fasCog,
  faBook as fasBook,
  faInfoCircle as fasInfoCircle,
  faBan as fasBan
} from '@fortawesome/free-solid-svg-icons'

import {
  faCompass as farCompass,
  faCircle as farCircle,
  faDotCircle as farDotCircle,
  faCopy as farCopy
} from '@fortawesome/free-regular-svg-icons'

library.add(
  // Font Aawesome SOLID (FAS)
  fasCompass,
  fasCircle,
  fasUser,
  fasUserCircle,
  fasBars,
  fasSignOutAlt,
  fasTimes,
  fasExclamationTriangle,
  fasCheckCircle,
  fasChevronUp,
  fasChevronDown,
  fasChevronLeft,
  fasChevronRight,
  fasMapMarkerAlt,
  fasPlusCircle,
  fasPlus,
  fasSort,
  fasExchangeAlt,
  fasFolderOpen,
  fasPen,
  fasSignInAlt,
  fasSpinner,
  fasThLarge,
  fasEnvelope,
  fasCheck,
  fasSeach,
  fasRocket,
  fasStar,
  fasMagic,
  fasAsterisk,
  fasArrowsAlt,
  fasArrowAltCircleDown,
  fasLongArrowAltDown,
  fasCalendarAlt,
  fasLongArrowAltRight,
  fasShareAlt,
  fasFileAlt,
  fasFileContract,
  fasTags,
  fasMapMarkedAlt,
  fasGlobeAmericas,
  fasClipboardList,
  fasFileInvoice,
  fasStar,
  fasCompressArrowsAlt,
  fasExpandArrowsAlt,
  fasTrashAlt,
  fasListUl,
  fasListAlt,
  fasUserEdit,
  fasFillDrip,
  fasDownload,
  fasUpload,
  fasGlobe,
  fasEye,
  fasEdit,
  fasAngleLeft,
  fasAngleDoubleLeft,
  fasAngleRight,
  fasAngleDoubleRight,
  fasPrint,
  fasCog,
  fasBook,
  fasInfoCircle,
  fasBan,
  // Font Aawesome REGULAR (FAR)
  farCompass,
  farCircle,
  farDotCircle,
  farCopy
)

export default function (vueInstance) {
  vueInstance.component('font-awesome-icon', FontAwesomeIcon)
}
